import React, { useRef } from "react";
import ReactToPrint from "react-to-print";
import { Col } from "react-bootstrap";
import "./style.css";
import moment from "moment";

const BillingReportPreview = ({ data, setShowPreviewModal }) => {
    const printRef = useRef();
    const clinicAddressDetails = JSON.parse(localStorage.getItem("clinicAddressDetails"))
    const clinicName = localStorage.getItem("clinicName")

    return (
        <div>
            <div
                className="row"
                style={{ display: "flex", justifyContent: "space-between" }}
            >
                <Col sm={6} md={6} lg={6}>
                    <div className="backbtn-container-sections">
                        <button
                            className="btn btn-fill btn-primary"
                            onClick={() => setShowPreviewModal(false)}
                        >
                            Back
                        </button>
                    </div>
                </Col>
                <Col sm={6} md={6} lg={6} style={{ textAlign: "right" }}>
                    <ReactToPrint
                        content={() => printRef.current}
                        trigger={() => (
                            <button className="btn btn-fill btn-primary">🖨️ Print</button>
                        )}
                        documentTitle="Billing Summary Report"
                    />
                </Col>
            </div>

            <div ref={printRef} className="print-section">
                {data && data.summary && data.summary.length > 0 ? (
                    <>
                        <div className='text-center cus-mb-2'>
                            <h4 className='cus-pb-5 cus-mb-0 self-mb-5 clr-font-bluesky' style={{ fontWeight: "500" }}>{clinicName}</h4>
                            <p className='cus-mb-0 img-des'>{clinicAddressDetails?.address} - {clinicAddressDetails?.pin_code} ({clinicAddressDetails?.state}) Phone No. {clinicAddressDetails?.phone}</p>

                            <h5 className='cus-mb-0' style={{ fontWeight: "600", marginTop: '12px' }} >Billing Summary</h5>
                        </div>
                        {/* Date Range Display */}
                        <div style={{
                            justifySelf: "flex-end",
                            fontSize: "14px",
                            background: "#f2f2f2",
                            border: "1px solid #ddd",
                            borderRadius: "4px",
                            padding: "12px 16px",
                            display: "block",
                            margin: "13px auto",
                            width: "fit-content"
                        }}>
                            {data.from === data.to ? (
                                <>
                                    <strong>Report Date:</strong> {data.fromPrintDate}
                                </>
                            ) : (
                                <>
                                    <strong>Report Period:</strong> {data.fromPrintDate} — {data.toPrintDate}
                                </>
                            )}
                        </div>

                        <table
                            style={{
                                width: "100%",
                                borderCollapse: "collapse",
                                margin: "auto",
                                fontSize: "14px",
                            }}
                        >
                            <thead>
                                <tr style={{ backgroundColor: "#f2f2f2" }}>
                                    <th style={thStyle}>#</th>
                                    <th style={thStyle}>Service</th>
                                    <th style={thStyle} className="ourcustom">No. Of Patients</th>
                                    <th style={thStyle} className="spc-align" >Amount (INR)</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.summary.map((item, idx) => (
                                    <tr key={idx} style={{ borderBottom: "1px dashed #ccc" }}>
                                        <td style={tdStyle}>{idx + 1}</td>
                                        <td style={tdStyle}>{item.service}</td>
                                        <td style={{ ...tdStyle, textAlign: "center" }}>
                                            {item.patientCount}
                                        </td>
                                        <td style={{ ...tdStyle, textAlign: "right" }}>
                                            {item.totalAmount.toFixed(2)}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                        {/* ✅ Totals Section (table ke niche) */}
                        <div
                            className="totals-container d-flex flex-column"
                            style={{
                                marginTop: 18,
                                gap: 6,
                                fontSize: 13,
                                alignItems: "flex-end",
                            }}
                        >
                            <div style={itemStyle}>
                                <strong>Total Collection:</strong>{" "}
                                {data.totals.totalCollection.toFixed(2)}
                            </div>
                            <div style={itemStyle}>
                                <strong>Total Billing:</strong>{" "}
                                {data.totals.totalBilling.toFixed(2)}
                            </div>
                            <div style={itemStyle}>
                                <strong>Total Cash:</strong> {data.totals.totalCash.toFixed(2)}
                            </div>
                            <div style={itemStyle}>
                                <strong>Total UPI:</strong> {data.totals.totalUPI.toFixed(2)}
                            </div>
                            <div style={itemStyle}>
                                <strong>Total Card:</strong> {data.totals.totalCard.toFixed(2)}
                            </div>
                            <div style={itemStyle}>
                                <strong>Total Discount:</strong>{" "}
                                {data.totals.totalDiscount.toFixed(2)}
                            </div>
                            <div style={itemStyle}>
                                <strong>Total Refund:</strong>{" "}
                                {data.totals.totalRefund.toFixed(2)}
                            </div>
                            <div style={itemStyle}>
                                <strong>Total Recovery:</strong>{" "}
                                {data.totals.totalRecovery.toFixed(2)}
                            </div>
                            <div style={itemStyle}>
                                <strong>Total Remaining:</strong>{" "}
                                {data.totals.totalRemaining.toFixed(2)}
                            </div>
                        </div>
                    </>
                ) : (
                    <p style={{ textAlign: "center" }}>No billing data available.</p>
                )}
            </div>
        </div>
    );
};


// 🔹 Common cell styles
const thStyle = {
    padding: "8px",
    borderBottom: "2px solid #000",
    // textAlign: "left",
};

const tdStyle = {
    padding: "8px",
    borderBottom: "1px dashed #999",
};

// 🔹 Totals item style
const itemStyle = {
    background: "#f4f8fb",
    borderRadius: 4,
    textAlign: "right",
    padding: "4px 10px",
    minWidth: 220,
};

export default BillingReportPreview;
